import InvoiceCell from './InvoiceCell';

export default InvoiceCell;
